import React, { useState } from 'react';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import BaseFilter, {
  FilterTypeEnum,
} from '../../../components/base/BaseFilter';
import { ArrayStringData } from '../../../utils';
import { TRANSACTION_EVENT_TYPE } from './TransactionList';
import { tierTypeConfig } from 'config/TierTypeConfig';

function Filter({ backAction = () => {} }) {
  const location = useLocation();

  const parsedSearch = queryString.parse(location.search);
  const searchTransactionType = parsedSearch['transaction_type'] || '';
  const searchOnlineEventType = parsedSearch['online_event_type'] || '';
  const searchOfflineEventType = parsedSearch['offline_event_type'] || '';
  const searchCode = parsedSearch['gift_card_code'] || '';
  const searchCreateDate = parsedSearch['transaction_date'] || '';
  const searchCreationPeriod = parsedSearch['create_date'] || '';
  const searchPurchasedDate = parsedSearch['purchased_date'] || '';
  const searchUploadDate = parsedSearch['receipt_upload_time'] || '';

  const [transactionType, setTransactionType] = useState(
    ArrayStringData(searchTransactionType),
  );
  const [onlineEventType, setOnlineEventType] = useState(
    ArrayStringData(searchOnlineEventType),
  );
  const [offlineEventType, setOfflineEventType] = useState(
    ArrayStringData(searchOfflineEventType),
  );
  const [code, setCode] = useState(searchCode);
  const [transactionDate, setTransactionDate] = useState(searchCreateDate);
  const [creationPeriod, setCreationPeriod] = useState(searchCreationPeriod);
  const [purchasedDate, setPurchasedDate] = useState(searchPurchasedDate);
  const [uploadDate, setUploadDate] = useState(searchUploadDate);

  const content = [
    {
      title: 'Transaction type',
      data: [
        { name: 'Offline Sales', pk: 'OFFLINE_POS' },
        { name: 'Offline(Reward claim)', pk: 'OFFLINE_REWARD_CLAIM' },
        { name: 'Online', pk: 'ONLINE' },
      ].filter(option => {
        if (!tierTypeConfig.onlineStore && option.pk === 'ONLINE') {
          return false;
        };
        return true;
      }),
      value: transactionType,
      setValue: setTransactionType,
      component: FilterTypeEnum.choice,
    },
    {
      hide: !tierTypeConfig.onlineStore,
      title: 'Online event type',
      data: [
        { name: TRANSACTION_EVENT_TYPE.TYPE_PENDING, pk: 'PENDING' },
        { name: TRANSACTION_EVENT_TYPE.TYPE_AUTHORIZED, pk: 'AUTHORIZED' },
        {
          name: TRANSACTION_EVENT_TYPE.TYPE_PARTIALLY_PAID,
          pk: 'PARTIALLY_PAID',
        },
        { name: TRANSACTION_EVENT_TYPE.TYPE_PAID, pk: 'PAID' },
        {
          name: TRANSACTION_EVENT_TYPE.TYPE_PARTIALLY_REFUNDED,
          pk: 'PARTIALLY_REFUNDED',
        },
        { name: TRANSACTION_EVENT_TYPE.TYPE_REFUNDED, pk: 'REFUNDED' },
        { name: TRANSACTION_EVENT_TYPE.TYPE_VOIDED, pk: 'VOIDED' },
      ],
      value: onlineEventType,
      setValue: setOnlineEventType,
      component: FilterTypeEnum.choice,
    },
    {
      title: 'Offline event type',
      data: [
        { name: TRANSACTION_EVENT_TYPE.TYPE_PENDING, pk: 'PENDING' },
        { name: TRANSACTION_EVENT_TYPE.TYPE_AUTHORIZED, pk: 'AUTHORIZED' },
        {
          name: TRANSACTION_EVENT_TYPE.TYPE_PARTIALLY_PAID,
          pk: 'PARTIALLY_PAID',
        },
        { name: TRANSACTION_EVENT_TYPE.TYPE_PAID, pk: 'PAID' },
        {
          name: TRANSACTION_EVENT_TYPE.TYPE_PARTIALLY_REFUNDED,
          pk: 'PARTIALLY_REFUNDED',
        },
        { name: TRANSACTION_EVENT_TYPE.TYPE_REFUNDED, pk: 'REFUNDED' },
        { name: TRANSACTION_EVENT_TYPE.TYPE_VOIDED, pk: 'VOIDED' },
        {
          name: TRANSACTION_EVENT_TYPE.TYPE_WAITING,
          pk: 'WAITING_FOR_APPROVAL',
        },
        { name: TRANSACTION_EVENT_TYPE.TYPE_APPROVED, pk: 'APPROVED' },
        { name: TRANSACTION_EVENT_TYPE.TYPE_RECALLED, pk: 'RECALLED' },
        { name: TRANSACTION_EVENT_TYPE.TYPE_REJECTED, pk: 'REJECTED' },
        { name: TRANSACTION_EVENT_TYPE.TYPE_EXCHANGE, pk: 'EXCHANGE' },
      ],
      value: offlineEventType,
      setValue: setOfflineEventType,
      component: FilterTypeEnum.choice,
    },
    {
      title: 'Gift card code',
      placeholder: 'Search by Gift card code',
      value: code,
      setValue: setCode,
      component: FilterTypeEnum.inputWithTitle,
    },
    {
      title: 'Transaction date',
      value: transactionDate,
      setValue: setTransactionDate,
      component: FilterTypeEnum.dateRange,
    },
    {
      title: 'Create date',
      value: creationPeriod,
      setValue: setCreationPeriod,
      component: FilterTypeEnum.dateRange,
    },
    {
      title: 'Purchased date',
      value: purchasedDate,
      setValue: setPurchasedDate,
      component: FilterTypeEnum.dateRange,
    },
    {
      title: 'Receipt upload time',
      value: uploadDate,
      setValue: setUploadDate,
      component: FilterTypeEnum.dateRange,
    },
  ];

  return <BaseFilter content={content} backAction={backAction} />;
}

export default Filter;
